import Vue from 'vue';
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
let lang=uni.getStorageSync('lang'),
default_lang='en-us'
if(lang == undefined ||lang== "" ||lang== null){
	uni.setStorageSync('lang',default_lang)
}
export const i18n = new VueI18n({
	locale: (lang == undefined ||lang== "" ||lang== null )?default_lang : lang,
	messages: {
		'zh-cn': require("./lang/text-ch.js"),
		'en-us':require('./lang/text-en.js'),
		'en-cs':require('./lang/text-en.js'),
		'th-th':require('./lang/taiyu.js'),
		'fr':require('./lang/fr.js'),
		'pt':require('./lang/pt.js'),
		'ja':require('./lang/ja.js'),
		'ma':require('./lang/ma.js'),
		'hy':require('./lang/hy.js'),
		'jp':require('./lang/jp.js'),
		'ca-es':require('./lang/ca-es.js')
	}
})
export const lang_list={
	'en-us':'English',
	'en-cs':'Canada',
	'fr':'Français',
	'pt':'Portugal',
	'zh-cn':'中文',
	'th-th':'ภาษาไทย',
	'ja':'Русский',
	'ma':'Melayu',
	'hy':'한국인',
	'jp':'にほん/にっぽん',
	'ca-es':'España'
}